import { FieldErrors } from 'react-hook-form';

/**
 * Recursive function to traverse form state. Looking for error messages.
 * See the test file for an examples
 *
 * @param errors - The form state containing the errors.
 * @returns An array of error messages.
 */
const getErrors = (errors: any) => {
  const errorList: string[] = [];
  for (const key in errors) {
    if (key === 'ref') {
      return;
    }

    if (errors[key]?.message) {
      errorList.push(errors[key]?.message);
    }

    if (typeof errors[key] === 'object' && key !== 'message') {
      const foundErrors = getErrors(errors[key]);
      if (foundErrors) {
        errorList.push(...foundErrors);
      }
    }
  }
  return errorList;
};

const getErrorsFromFormState = (errors: FieldErrors): string[] => {
  const errorMessages = getErrors(errors);

  // filter out duplicated errors
  const filteredErrorSummary = errorMessages?.filter(
    (error, index, self) => self.indexOf(error) === index,
  );

  return filteredErrorSummary || [];
};

export default getErrorsFromFormState;
